import { createEntityByIdSource } from 'serviceWorker/channelServers/entitySource';
import * as dbSites from 'serviceWorker/db/sites/sites';
import * as dbSitesService from 'serviceWorker/db/sites/sitesService';
import { getCurrentUsers } from 'serviceWorker/services/users/getUsers';
import { siteEntityToModel } from 'shared/domain/site/mapping/toModel';
import { siteContract } from 'shared/domain/site/siteContract';
import { sitesSync } from './index';

/** Sites of IndexedDB, with the users downloaded so far (a missing users download must not block them). */
export const siteSource = createEntityByIdSource({
  service: dbSitesService,
  contract: siteContract,
  ...sitesSync,
  readAll: async () => {
    const [sites, users] = await Promise.all([dbSites.get(), getCurrentUsers()]);
    return sites.map((site) => siteEntityToModel(site, users));
  },
  readOne: async (id) => {
    const [site, users] = await Promise.all([dbSites.getOne(id), getCurrentUsers()]);
    return site && siteEntityToModel(site, users);
  },
});
